import { colorTool } from './color';
import { copyTool } from './copy';
import { moveTool } from './move';
import { noteTool } from './note';
import { redrawTool } from './redraw';
import { trashTool } from './trash';

export * from './core';

export const tools = [
  colorTool,
  copyTool,
  moveTool,
  noteTool,
  redrawTool,
  trashTool
];



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/index.js